import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import bowser from 'bowser'
import { useEffectOnce } from 'react-use'

import { WindowTitleComponent } from '../../../../sharedLegacy/components'
import SecondCamVideoPreview from '../../SecondCamVideoPreview/SecondCamVideoPreview'
import { getWebinarTitle } from '../../../selectors'
import { initWebinar as initWebinarAction, actionNames } from '../../../actions'
import { useConnectInfoQuery } from '../../../../global/blocs/useConnectInfo'
import { useRoomGlobalInfo } from '../../../../global/blocs/roomInfo'
import {
  connect as connectToProvider,
  useRoomStatus,
} from '../../../../webrtc/webRTCRoom'

import Connecting from './Connecting'

const Root = styled.div`
  flex: 1;
  padding: 0;
  height: 100%;
  width: 100%;
`

const SecondCamLayout = ({
  /**
   * Connected properties
   */
  webinarTitle,
  webinarEnded,

  /**
   * Connected functions
   */
  initWebinar,
}) => {
  const { data: webinarConnectInfo } = useConnectInfoQuery()
  const connectStatus = useRoomStatus()
  const { liveId, presenterToken } = useRoomGlobalInfo()
  const dispatch = useDispatch()
  const role = 'presenter'
  const isMobile = bowser.mobile

  useEffect(() => {
    initWebinar({
      liveId,
      role,
      debug: false,
      presenterToken,
      isSecondCam: true,
      isMobileDevice: isMobile,
    })
  }, [liveId, role, initWebinar, presenterToken, isMobile])

  useEffectOnce(() => {
    connectToProvider().then(() => {
      dispatch({ type: actionNames.TWILIO_CONNECTED })
      dispatch({ type: actionNames.CONNECT_TO_WEBINAR })
    })
  })

  /*
   * Legacy: update Redux store with connect info
   * TODO: delete when Redux dependency is removed
   */
  useEffect(() => {
    if (!webinarConnectInfo) {
      return
    }

    dispatch({
      type: actionNames.FETCH_CONNECTION_INFO_SUCCESS,
      authInfo: {
        webrtc_room: webinarConnectInfo.webrtc_room,
        webrtc_authenticator: webinarConnectInfo.webrtc_authenticator,
        webrtc_data_authenticator: webinarConnectInfo.webrtc_data_authenticator,
      },
      presenterToken: webinarConnectInfo.presenter_token,
      liveAuthToken: webinarConnectInfo.token,
      firebaseToken: webinarConnectInfo.webrtc_data_authenticator,
      siteLogo: webinarConnectInfo.custom_logo_url,
      streaming_method: webinarConnectInfo.streaming_method,
      liveSpeakerId: webinarConnectInfo.live_speaker_id,
      isGearMode: webinarConnectInfo.streaming_method === 'hardware',
    })
  }, [dispatch, webinarConnectInfo, connectStatus])

  return (
    <>
      <Root>
        <WindowTitleComponent title={webinarTitle} />
        {!webinarEnded && (
          <>
            <Connecting />
            <SecondCamVideoPreview />
          </>
        )}
      </Root>
    </>
  )
}

SecondCamLayout.propTypes = {
  /**
   * Connected properties
   */
  webinarTitle: PropTypes.string,
  webinarEnded: PropTypes.bool,

  /**
   * Connected functions
   */
  initWebinar: PropTypes.func,
}

const mapStateToProps = (state) => ({
  /**
   * Connected properties
   */
  webinarTitle: getWebinarTitle(state),
  webinarEnded: state.webinar.webinarEnded,
})

const mapDispatchToProps = {
  /**
   * Connected functions
   */
  initWebinar: initWebinarAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondCamLayout)
